import { useEffect } from "react";

const SITE = "https://frenchiesfitness.com";

// Lightweight per-page SEO: updates the existing head tags in place (no duplicates),
// so client-side navigation and JS-rendering crawlers (Google) get the right title/meta.
// Static social scrapers (Facebook/WhatsApp) still read the defaults from index.html.
export function Seo({ title, description, path = "", keywords, image, jsonLd, noindex = false, breadcrumbs }) {
  useEffect(() => {
    const url = SITE + path;
    if (title) document.title = title;
    const set = (sel, attr, val) => {
      if (val == null) return;
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    set('meta[property="og:image"]', "content", image);
    set('meta[name="twitter:image"]', "content", image);
    set('meta[name="description"]', "content", description);
    set('meta[name="keywords"]', "content", keywords);
    set('link[rel="canonical"]', "href", url);
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.setAttribute("href", url));
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", url);
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.name = "robots"; document.head.appendChild(robots); }
    robots.content = noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";

    const blocks = [];
    if (jsonLd) blocks.push(...(Array.isArray(jsonLd) ? jsonLd : [jsonLd]));
    if (breadcrumbs?.length) {
      blocks.push({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [{ "@type": "ListItem", position: 1, name: "Inicio", item: SITE + "/" },
          ...breadcrumbs.map((b, i) => ({ "@type": "ListItem", position: i + 2, name: b.name, item: SITE + b.path }))],
      });
    }
    const id = "seo-page-ldjson";
    document.getElementById(id)?.remove();
    if (blocks.length) {
      const s = document.createElement("script");
      s.type = "application/ld+json"; s.id = id;
      s.textContent = JSON.stringify(blocks.map((b) => ({ "@context": "https://schema.org", ...b })));
      document.head.appendChild(s);
    }
    return () => { document.getElementById(id)?.remove(); };
  }, [title, description, path, keywords, image, jsonLd, noindex, breadcrumbs]);
  return null;
}
